import React, { useState } from 'react';
import { Form, useNavigation } from 'react-router-dom';
import { Switch } from '@headlessui/react';
import HeaderEinstellungen from './HeaderEinstellungen';
import { toast } from 'react-toastify';
import customFetch from '../../../utils/customFetch';
import MusterEinstellungen from './MusterEinstellungen';
import Farbeinstellungen from './Farbeinstellungen';
import HeaderUpload from './HeaderUpload';

export const action =
  (queryClient) =>
  async ({ request }) => {
    const formData = await request.formData();

    const file = formData.get('headerContent');

    if (file && file.size > 5000000) {
      toast.error('Das Bild darf nicht grösser als 5MB sein');
      return null;
    }

    try {
      await customFetch.patch('/links/settings/erscheinungsbild', formData);
      queryClient.invalidateQueries(['erscheinungsbild']);
      toast.success('Erfolgreich angepasst!');
      return null;
    } catch (error) {
      toast.error(error?.response?.data?.msg);
      return error;
    }
  };

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ErscheinungsbildForm = ({
  linkColor,
  iconColor,
  showHeader,
  backgroundType,
  backgroundContent,
  headerContent,
}) => {
  const [enabled, setEnabled] = useState(showHeader);
  const [radioBackgroundType, setRadioBackgroundType] =
    useState(backgroundType);

  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <Form method="POST" encType="multipart/form-data">
      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Links
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            Beeinflusse die Farbe deiner Links und der Icons.
          </p>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-1">
              <label
                htmlFor="linkColor"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Textfarbe
              </label>
              <div className="mt-2">
                <input
                  type="color"
                  name="linkColor"
                  id="linkColor"
                  defaultValue={linkColor}
                />
              </div>
            </div>
            <div className="sm:col-span-1">
              <label
                htmlFor="iconColor"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Iconfarbe
              </label>
              <div className="mt-2">
                <input
                  type="color"
                  name="iconColor"
                  id="iconColor"
                  defaultValue={iconColor}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Header
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            Das Bild hinter deinem Profilbild. Standardmässig wird hier nichts
            angezeigt, du kannst aber ein Bild hochladen (Zum Beispiel ein Bild
            mit einem Firmenlogo). Achte darauf, dass das Bild ein Verhältnis
            von 2:1 hat. Für eine optimale Darstellung empfehlen wir mindestens
            1500 x 750 Pixel.
          </p>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-4">
              <p className="block text-sm font-medium leading-6 text-gray-900">
                Header anzeigen
              </p>
              <div className="mt-2">
                <Switch
                  checked={enabled}
                  onChange={setEnabled}
                  className={classNames(
                    enabled ? 'bg-svisit-primary-600' : 'bg-gray-200',
                    'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-600 focus:ring-offset-2'
                  )}
                >
                  <span className="sr-only">Use setting</span>
                  <span
                    aria-hidden="true"
                    className={classNames(
                      enabled ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'
                    )}
                  />
                  <input
                    type="hidden"
                    name="showHeader"
                    id="showHeader"
                    defaultValue={enabled}
                  />
                </Switch>
              </div>
            </div>
            {enabled ? <HeaderUpload headerContent={headerContent} /> : ''}
          </div>
        </div>
        {/* Ab hier Background Einstellungen */}
        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Hintergrund
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            Hier kannst du einstellen, wie der Hintergrund deiner Seite aussehen
            soll. Standardmässig ist ein kein Hintergrund eingestellt.
          </p>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-4">
              <p className="block text-sm font-medium leading-6 text-gray-900">
                Hintergrundtyp
              </p>
              <fieldset className="mt-4">
                <div className="mt-2 space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
                  <div className="flex items-center">
                    <input
                      id="Farbe"
                      name="backgroundType"
                      type="radio"
                      value="Farbe"
                      defaultChecked={backgroundType === 'Farbe'}
                      onChange={() => setRadioBackgroundType('Farbe')}
                      className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                    />
                    <label
                      htmlFor="Farbe"
                      className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      Farbe
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="Muster"
                      name="backgroundType"
                      type="radio"
                      value="Muster"
                      onChange={() => setRadioBackgroundType('Muster')}
                      defaultChecked={backgroundType === 'Muster'}
                      className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                    />
                    <label
                      htmlFor="Muster"
                      className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      Muster
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      id="Keiner"
                      name="backgroundType"
                      value="Keiner"
                      onChange={() => setRadioBackgroundType('Keiner')}
                      type="radio"
                      defaultChecked={backgroundType === 'Keiner'}
                      className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                    />
                    <label
                      htmlFor="Keiner"
                      className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                    >
                      Keiner
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            {radioBackgroundType === 'Farbe' ? (
              <Farbeinstellungen backgroundContent />
            ) : radioBackgroundType === 'Muster' ? (
              <MusterEinstellungen
                defaultType={
                  backgroundType === 'Muster' ? backgroundContent : 'Topografie'
                }
                name="backgroundContent"
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          type="submit"
          className="rounded-md bg-svisit-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Speichert...' : 'Speichern'}
        </button>
      </div>
    </Form>
  );
};

export default ErscheinungsbildForm;
